import { Modal } from '@dynamika-shared/ui/Modal/Modal';
import { twJoin } from '@dynamika-shared/utils/twMerge';
import { FC } from 'react';
type UnsavedChangesProps = {
  dark?: boolean;
  onCancel?: () => void;
  onConfirm?: () => void;
  open: boolean;
};

export const UnsavedChangesModal: FC<UnsavedChangesProps> = ({
  dark,
  onCancel,
  onConfirm,
  open,
}) => {
  return open ? (
    <Modal
      width={440}
      onCancel={onCancel}
      onOk={onConfirm}
      okText='Yes, Exit'
      centered
      cancelText='Cancel'
      cancelProps={{ darkMode: dark }}
      maskClosable={false}
      open={open}
      mask={false}
      okClassName='ant-btn-dangerous'
      classNames={{
        header: twJoin(
          'text-left !mb-3',
          dark && '!bg-darkCharcoal [&_h2]:!text-white'
        ),
        content: twJoin(
          'text-center !rounded-[2.4rem] !p-[4rem]',
          dark && '!bg-darkCharcoal text-white [&_svg]:!text-pastelBlue'
        ),
        footer: 'flex justify-between !mt-3',
      }}
      title='Unsaved changes'
      titleClassName='text-left'
      data-testid={'unsaved-changes-popup'}
    >
      Are you sure you want to exit?
      <br />
      Your progress will not be saved.
    </Modal>
  ) : null;
};
